import React,{useEffect,useState,useRef} from 'react';
import { Col, Container, Row } from 'react-bootstrap'
import * as AuthVerify from '../../lib/common';
import Axios from '../../lib/axios/axiosInstance';
import Modal from 'react-bootstrap/Modal';
import { Space, Table } from 'antd';
import { Link } from "react-router-dom";
import Loader from '../Common/loader';

const CostCenterAndCatalog = () => {

  const [acccountDetails, setAcccountDetails] = useState(false);
  const [dashboard, setDashboard] = useState(false);
  const [cData, setCData] = useState(false);
  const [askingForDraft, setAskingForDraft] = useState(false);

  const reqForCC = useRef();
  const activeselectedItem = useRef();

  const checkCartItems = async (item,reqFor,isActive) => {
    if(isActive){
      return true;
    }
    else{
      reqForCC.current=reqFor; 
      activeselectedItem.current=item;
      await AuthVerify.getCartDeatils(true).then(data => {
        if(data?.items?.length > 0) {
          setAskingForDraft(true);
        }else{
          if(reqForCC.current)setActiveCC(false);
          else setActiveC(false);
        }
      })
    }
  }

  const actionPerformed = (result) => {
    if(reqForCC.current){
      setActiveCC(result);
    }else{
      setActiveC(result);
    }
  }

  const setActiveCC =async (result) => {
    // api/account/costcenter
    activeselectedItem.current?.catalogs.map(item=>{
      item.active = false;
    });
    setCData(activeselectedItem.current.catalogs);
    const data={
      costcentersetting: {
        ccnum: activeselectedItem.current.ccnum,
        catalognum: ""
      }
    }
    await Axios.post(`/account/costcenter`,data)
      .then(async (data) => {
        if(data?.data?.data){
          setDashboard(data.data.data);
          if(result==false)AuthVerify.deleteCartItems();
          else{
            AuthVerify.saveAsDraft();
            AuthVerify.getCartRef(true);
          }
        }
      });
      setAskingForDraft(false);
    return false;
  };

  const setActiveC =async (result) => {
    const activeCC = dashboard.filter(x=>x.active)[0];
    if(activeCC){
      const data={
        costcentersetting: {
          ccnum: activeCC.ccnum,
          catalognum: activeselectedItem.current.catalognum
        }
      }
      await Axios.post(`/account/costcenter`,data)
        .then(async (data) => {
          if(data.data?.data){
            const catalog=data.data.data.filter(x=>x.active)[0];
            setCData(catalog.catalogs);
            if(result==false)AuthVerify.deleteCartItems();
            else{
              AuthVerify.saveAsDraft();
              AuthVerify.getCartRef(true);
            }
          }
        });
      setAskingForDraft(false);
    }
    return false;
  };

  useEffect(async () => {
      setAcccountDetails(AuthVerify.getUser());
      await Axios.get(`/account/costcenter`)
        .then(async (data) => {
          if(data.data?.data){
            var catalogList = [];
            setDashboard(data.data.data);
            data.data.data.map((item)=>{
              if(item.active)
              catalogList = item.catalogs;
            })
            if(!catalogList){
              catalogList = data.data.data[0].catalogs;
            }
            setCData(catalogList);
          }
          else{
            setCData([]);
            setDashboard([]);
          }
        });
  }, [])
  
  return (
        <>
        {
        acccountDetails.role=='Corporate' && AuthVerify.getPermissions("CostCenter")?.menuaccess &&
            <>
            {dashboard ? 
            <div className="box-account" style={{ display: "grid" }}>
                <div className="page-title">
                <h2>Your Cost Center</h2>
                </div>
                <div className="header-nav-dropdown-wrapper" style={{ display: "flex", flexWrap: "wrap" }}>
                {dashboard.length>0 ? dashboard.map((item,i)=>{
                    var style = {
                    width: "20%"
                    };
                    if(item.active){
                    style.border="3px #5aa0dd solid";
                    }
                    return (
                    <button key={i}
                        onClick={() => checkCartItems(item,true,item.active)}
                        className="jtv-custom-box"
                        style={style}
                    >
                        <i className="fa fa-archive"></i>
                        <h5 className="heading" style={{ marginBottom: "0",marginTop:"5px" }}>
                        {item.ccname}
                        </h5>
                        {item.active && <small style={{ color: "#3c763d" }}>Active</small> }
                        <p></p>
                    </button>
                    )
                }):<p>No cost center found !</p>}
                </div>
            </div>:<Loader/>}

            {cData ? 
            <div className="box-account" style={{ display: "grid" }}>
                <div className="page-title">
                <h2>Your Catalog</h2>
                </div>
                <div className="header-nav-dropdown-wrapper header-nav-dropdown-wrapper-1">
                    {cData.length>0 ? cData.map((catalog,i)=>{
                    var style = {
                        width: "20%"
                    };
                    if(catalog.active){
                        style.border="3px #5aa0dd solid";
                    }
                    return (
                        <button key={i}
                        onClick={() => checkCartItems(catalog,false,catalog.active)} className="jtv-custom-box" style={{...style, height:"100px"}}>
                        <h5 className="heading" style={{ marginBottom: "0",marginTop:"5px" }}>
                        <i
                            className="fa fa-clipboard"
                            style={{
                            fontSize: "20px",
                            padding: "0",
                            marginTop: "20px",
                            border: "0",
                            background: "transparent",
                            }}
                        ></i>{" "}
                        {catalog.catalogname}
                        </h5>
                        {catalog.active && <small style={{color: "#3c763d"}}>Active</small> }
                        <p></p>
                    </button>
                    )
                    }):<p>No catalog found !</p>}
                
                </div>
            </div>:<Loader/>}
            <br />
            </>
        }

        <Modal show={askingForDraft} scrollable={false} size="sm" centered animation={false} fade={false} style={{opacity:1,margin:"auto"}} onHide={()=>setAskingForDraft(false)}>
        <Modal.Header closeButton={false}>
				  <Modal.Title>There are some products found in your cart !</Modal.Title>
				</Modal.Header>
          <Modal.Body style={{textAlign:"center"}}>
           Do you want to save those products as draft for further use ?
          </Modal.Body>
          <Modal.Footer>
          <div  style={{float:"right"}}>
            <button
              className="button "
              title="Proceed to Checkout"
              type="button"
              onClick={() => {actionPerformed(true)}}
              style={{
                marginRight: "10px",
                padding: "5px"
              }}
              >
              <span>Yes, Save as Draft</span>
            </button>
            <button
              className="button button-danger"
              title="Proceed to Checkout"
              type="button"
              onClick={() => {actionPerformed(false)}}
              style={{
                marginRight: "10px",
                padding: "5px"
              }}
              >
              <span>No, Continue</span>
            </button>
          </div>
          </Modal.Footer>
        </Modal>
        </>
  );
};

export default CostCenterAndCatalog;
